import { Box, Container, List, ListItem, Typography } from '@mui/material';

export function PrivacyPolicyEnglish({ sx, ...other }) {
  return (
    <Box
      component="section"
      sx={[
        {
          pb: 10,
          pt: { xs: 3, md: 10 },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      <Container>
        <Box>
          <Box display="flex" justifyContent="around">
            <Box>
              <Box>
                <Box sx={{ m: 5 }}>
                  <Typography
                    component="h5"
                    sx={{
                      fontWeight: 'bold',
                      fontSize: '24px',
                      margin: '10px 40px 0px 0px',
                      textAlign: 'center',
                    }}
                  >
                    Privacy Policy
                  </Typography>
                  {/* <!--------------- Introduction And Information Collection Related Policies --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Introduction</Typography>
                  <Typography>
                    Shahen platform, owned by Fikr for Telecommunications and Information
                    Technology, is committed to protecting your privacy and ensuring the security of
                    your personal information. This policy explains how we collect, use, and protect
                    your information when you use our services, whether through our mobile
                    application or our website. By using Shahen, you agree to the terms outlined in
                    this policy.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Privacy Policy</Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    1.Information Collection
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>
                    {' '}
                    1.1 Types of Information Collected
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4, ml: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Personal Information :
                        </Typography>{' '}
                        Includes your name, address, phone number, email address, and any other
                        information that can identify you as an inBoxidual.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Non-Personal Information :
                        </Typography>{' '}
                        Includes data that does not directly identify you, such as your device type,
                        IP address, browser type, usage data, and browsing history.{' '}
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Account Registration :
                        </Typography>{' '}
                        When you create an account, we collect personal information to set up your
                        profile and provide our services.
                      </Typography>
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>
                    {' '}
                    1.2 Methods of Collection
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4, ml: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Usage Data :
                        </Typography>{' '}
                        We collect information about your interactions with our platform, such as
                        pages visited, features used, and transaction history.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Third-Party Sources :
                        </Typography>{' '}
                        We may receive information from our partners and service providers to
                        enhance our services.
                      </Typography>
                    </ListItem>
                  </List>

                  {/* <!--------------- Use of Information Related Policies --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>2. Use of Information </Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>
                    {' '}
                    2.1 Service Improvement
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4, ml: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Enhancing User Experience :
                        </Typography>{' '}
                        We use your data to personalize and improve the functionality of our
                        platform, ensuring a better user experience.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Communication :
                        </Typography>{' '}
                        Your information helps us communicate with you about your account,
                        transactions, and updates to our services.
                      </Typography>
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>
                    {' '}
                    2.2 Security and Legal Compliance
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4, ml: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Data Protection :
                        </Typography>{' '}
                        We use your information to protect your account and the platform from
                        fraudulent activities.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Legal Requirements :
                        </Typography>{' '}
                        We may disclose your information to comply with legal obligations or respond
                        to legal requests from government authorities.
                      </Typography>
                    </ListItem>
                  </List>

                  {/* <!--------------- Cookies and Tracking Technologies Related Policies --------------------------> */}

                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    3. Cookies and Tracking Technologies{' '}
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>
                    3.1 Types of Cookies Used
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4, ml: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Essential Cookies :
                        </Typography>{' '}
                        Necessary for basic website functions, such as navigating secure areas.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Performance Cookies :
                        </Typography>{' '}
                        Collect information about how visitors use the site to help improve its
                        performance.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Functional Cookies :
                        </Typography>{' '}
                        Remember your preferences to provide enhanced and personalized features.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Advertising Cookies :
                        </Typography>{' '}
                        Deliver advertisements relevant to you and measure their effectiveness.
                      </Typography>
                    </ListItem>
                  </List>

                  <Typography sx={{ ml: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      3.2 Managing Cookies :
                    </Typography>{' '}
                    You can manage or delete cookies through your browser settings. Disabling
                    cookies may affect the functionality of our platform.
                  </Typography>

                  {/* <!--------------- Information Sharing and Disclosure  Related Policies --------------------------> */}

                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    4. Information Sharing and Disclosure{' '}
                  </Typography>

                  <Typography sx={{ ml: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      4.1 Third-Party Service Providers :
                    </Typography>{' '}
                    We share your data with trusted third parties that help us operate our platform,
                    such as payment processors, marketing partners, and IT service providers.
                  </Typography>
                  <Typography sx={{ ml: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      4.2 Legal Disclosures :
                    </Typography>{' '}
                    We may disclose your information in response to legal requests or to protect our
                    rights and property, as well as the safety of our users and the public.
                  </Typography>
                  <Typography sx={{ ml: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      4.3 Background Tracking :
                    </Typography>{' '}
                    We track the locations of drivers and shipments to improve delivery and for
                    internal purposes only.
                  </Typography>

                  {/* <!--------------- Data Security  Related Policies --------------------------> */}

                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>5. Data Security </Typography>

                  <Typography sx={{ ml: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      5.1 Security Measures :
                    </Typography>{' '}
                    We implement advanced security measures to protect your data from unauthorized
                    access, alteration, or destruction.
                  </Typography>
                  <Typography sx={{ ml: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      5.2 Data Retention :
                    </Typography>{' '}
                    We retain your data only as long as necessary to fulfill the purposes outlined
                    in this policy or as required by law.
                  </Typography>

                  {/* <!--------------- User Rights Related Policies --------------------------> */}

                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>6. User Rights </Typography>

                  <Typography sx={{ ml: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      6.1 Access and Correction :
                    </Typography>{' '}
                    You have the right to access the personal information we hold about you and
                    request its correction if it is inaccurate or incomplete.{' '}
                  </Typography>
                  <Typography sx={{ ml: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      6.2 Deletion :
                    </Typography>{' '}
                    You may request the deletion of your personal information unless there is a
                    legal or operational reason preventing us from doing so.
                  </Typography>
                  <Typography sx={{ ml: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      6.3 Data Portability :
                    </Typography>{' '}
                    You have the right to request the transfer of your personal information to
                    another service provider.
                  </Typography>
                  <Typography sx={{ ml: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      6.4 Objection and Restriction :
                    </Typography>{' '}
                    You can object to or request the restriction of processing your data under
                    certain circumstances.
                  </Typography>

                  {/* <!--------------- Policy Updates Related Policies --------------------------> */}

                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      7. Policy Updates :
                    </Typography>{' '}
                    We may update this privacy policy to reflect changes in our practices or legal
                    requirements. We will notify you of any significant changes via our platform or
                    through other appropriate means.
                  </Typography>
                  <br />

                  {/* <!--------------- Terms and Conditions Related Policies --------------------------> */}

                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Terms and Conditions </Typography>

                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      1. Acceptance of Terms :
                    </Typography>{' '}
                    By using Shahen, you agree to comply with these terms and conditions, which
                    constitute a legally binding agreement between you and Shahen.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      2. Service Description :
                    </Typography>{' '}
                    Shahen provides an electronic platform that connects customers needing
                    transportation services with carriers who own suitable trucks. Services include
                    daily and monthly rentals and other logistics solutions.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    3. User Responsibilities{' '}
                  </Typography>
                  <Typography sx={{ ml: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      3.1 Accurate Information :
                    </Typography>{' '}
                    You must provide accurate and complete information when creating your account
                    and using our services. Misrepresentation may lead to the suspension or
                    termination of your account.
                  </Typography>
                  <Typography sx={{ ml: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      3.2 Compliance with Laws :
                    </Typography>{' '}
                    You agree to comply with all applicable laws and regulations while using our
                    platform. Violations may lead to suspension or termination of your account.
                  </Typography>
                  <Typography sx={{ ml: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      3.3 Prohibited Activities :
                    </Typography>{' '}
                    You must not use our platform for any illegal or unauthorized purposes,
                    including transporting prohibited materials or engaging in fraudulent
                    activities.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>4. Fees and Payments </Typography>
                  <Typography sx={{ ml: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      4.1 Service Fees :
                    </Typography>{' '}
                    You agree to pay all fees associated with using our services, as detailed on our
                    platform. These may include rental fees, overtime charges, and late penalties.
                  </Typography>
                  <Typography sx={{ ml: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      4.2 Payment Terms :
                    </Typography>{' '}
                    Payments must be made through the methods specified on our platform. Delayed
                    payments may lead to suspension or termination of your account.
                  </Typography>

                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    5. Bookings and Cancellations{' '}
                  </Typography>
                  <Typography sx={{ ml: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      5.1 Booking Process :
                    </Typography>{' '}
                    All bookings must be made through the Shahen platform. You will receive
                    confirmation once your booking is accepted.
                  </Typography>
                  <Typography sx={{ ml: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      5.2 Cancellation Policy :
                    </Typography>{' '}
                    Cancellations are subject to the terms outlined in our service policies.
                    Cancellation fees may apply depending on the timing and nature of the
                    cancellation.
                  </Typography>

                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    6. Liability and Indemnification{' '}
                  </Typography>
                  <Typography sx={{ ml: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      6.1 Limitation of Liability :
                    </Typography>{' '}
                    Shahen is not liable for any direct, indirect, incidental, consequential, or
                    punitive damages arising from your use of the platform or services provided.
                  </Typography>
                  <Typography sx={{ ml: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      6.2 Indemnification :
                    </Typography>{' '}
                    You agree to indemnify and hold Shahen, its affiliates, officers, directors,
                    employees, and agents harmless from any claims or damages arising from your use
                    of the platform or your breach of these terms.
                  </Typography>

                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>7. Dispute Resolution </Typography>
                  <Typography sx={{ ml: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      7.1 Negotiation :
                    </Typography>{' '}
                    In the event of a dispute, parties should first attempt to resolve it through
                    direct negotiation within fifteen (15) days.{' '}
                  </Typography>
                  <Typography sx={{ ml: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      7.2 Arbitration :
                    </Typography>{' '}
                    If a resolution is not reached through negotiation, disputes will be settled
                    through arbitration according to the rules of the Saudi Center for Commercial
                    Arbitration. Arbitration will take place in Riyadh, Saudi Arabia, and
                    proceedings will be conducted in Arabic.
                  </Typography>

                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>8. Termination </Typography>
                  <Typography sx={{ ml: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      8.1 Termination by Shahen :
                    </Typography>{' '}
                    Shahen reserves the right to terminate your account at any time for any reason,
                    with or without notice.
                  </Typography>
                  <Typography sx={{ ml: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      8.2 Termination by User :
                    </Typography>{' '}
                    You can terminate your account by deleting the app and ceasing to use our
                    services.
                  </Typography>

                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      9. Intellectual Property :
                    </Typography>{' '}
                    All content on the Shahen platform, including text, graphics, logos, images, and
                    software, is owned by Shahen or its licensors and is protected under
                    intellectual property laws. You may not use any of this content without express
                    written permission from us.
                  </Typography>

                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    10. General Provisions{' '}
                  </Typography>
                  <Typography sx={{ ml: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      10.1 Entire Agreement :
                    </Typography>{' '}
                    These terms and conditions constitute the entire agreement between you and
                    Shahen regarding the use of our services.{' '}
                  </Typography>
                  <Typography sx={{ ml: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      10.2 Applicable Law :
                    </Typography>{' '}
                    This agreement is governed by the laws of the Kingdom of Saudi Arabia, and any
                    disputes will be resolved in Saudi courts.
                  </Typography>
                  <Typography sx={{ ml: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      10.3 Severability :
                    </Typography>{' '}
                    If any provision of these terms and conditions is found to be invalid or
                    unenforceable, the remaining provisions will remain in effect.
                  </Typography>
                  <br />
                  {/* <!--------------- Contact Us Boxision --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Contact Us </Typography>

                  <Typography>
                    If you have any questions or concerns about this privacy policy and terms and
                    conditions, please contact us at: Email: care@shahen-sa.com Phone: 0112299855
                  </Typography>
                  <br />
                  <Typography>
                    By using Shahen, you acknowledge that you have read, understood, and agree to
                    comply with this privacy policy and terms and conditions.
                  </Typography>
                  <br />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
